import ActionTypes from '../constants/ActionTypes';
import { State } from '../reducers';
import { Question } from '../interfaces/question';

const EMPTY_QUESTIONS: Question[] = [];
const EMPTY_MODAL_QUESTIONS = {};

export function areQuestionsLoaded(state: State, key: number) {
  return !!(
    state.questions.status[key] &&
    state.questions.status[key] === ActionTypes.FETCH_QUESTIONS_SUCCESS
  );
}

export function areModalQuestionsLoaded(state: State, key: string) {
  return !!state.questions.modal[key];
}

export function getQuestionsByCategoryKey(state: State, key: number) {
  return state.questions.list[key] || EMPTY_QUESTIONS;
}

export function getModalQuestionsByCategory(state) {
  return state.questions.modal || EMPTY_MODAL_QUESTIONS;
}
